import { makeActionCreator } from '../../../utilities'
import { PaymentInformationConstants } from './paymentInformation.constants'

export const setPrimaryMethodOfPayment = makeActionCreator(
  PaymentInformationConstants.SET_PRIMARY_METHOD_OF_PAYMENT,
  'primaryMethodOfPayment'
)
export const setPrimaryMethodOfPaymentPNNV = makeActionCreator(
  PaymentInformationConstants.SET_PRIMARY_METHOD_OF_PAYMENT_PNNV,
  'primaryMethodOfPaymentPNNV'
)
export const setX12PayerType = makeActionCreator(PaymentInformationConstants.SET_X12_PAYER_TYPE, 'x12PayerType')
export const setPriorAuthorizationPayer = makeActionCreator(
  PaymentInformationConstants.SET_PRIOR_AUTHORIZATION_PAYER,
  'priorAuthorizationPayer'
)
export const savePaymentInformation = makeActionCreator(PaymentInformationConstants.SAVE_PAYMENT_INFORMATION)

export const setPaymentInformation = makeActionCreator(
  PaymentInformationConstants.SET_PAYMENT_INFORMATION,
  'paymentInformation'
)

export const resetPaymentInformation = makeActionCreator(PaymentInformationConstants.RESET_PAYMENT_INFORMATION)
